<template>
	<router-link v-if="isRouter && !confirmed" :to="url"><slot></slot></router-link>
	<span v-else-if="isEmpty"><slot></slot></span>
	<a v-else :href="url"><slot></slot></a>
</template>

<script setup lang="ts">
import {computed} from "vue";
import {isRoute} from "@/router/Router";
import { useRouter } from "vue-router";
import {addContextParams, injectContext} from "@t/fd/AppContext.ts";

const props = defineProps<{
	to?: string,
	confirmed?: boolean,
	/** Add context parameters to the given URL */
	ctx?:boolean|string[]
}>();

const router = useRouter();

const isRouter = computed(() => {
	return isRoute(props.to);
});

const isEmpty = computed<boolean>(() => props.to == null || props.to.length === 0);

const url = computed(() => {
	let url = props.to;
	if (props.ctx) {
		const ctxMap = injectContext();
		url = addContextParams(url, ctxMap.value, props.ctx);
	}
	return url;
});

/** Programmatic navigation of the link */
function navigate() {
	if (isRouter.value) {
		// use logic for <router-link>
		router.push(url.value);
	} else {
		// use logic for <a>
		window.location.href = url.value;
	}
}

defineExpose({
	navigate
});
</script>

<style>

</style>